import { ScrollingModule } from "@angular/cdk/scrolling";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsDirectivesModule } from "@directives/_forms/_form.directives.module";
import { PipesModule } from "src/app/_pipes/_pipes.module";
import { CoreDirectivesModule } from "../_core/_core.directives.module";
import { MapDirectivesModule } from "../_map/_map.directives.module";
import { MiscDirectivesModule } from "../_misc/_misc.directives.module";
import { ResourceFiltersDirectivesModule } from "../_resourceFilters/_resourceFilters.directives.module";
import { VeriDirectivesModule } from "../_veri/_veri.directives.module";
import { DriverSummaryPanelComponent } from "./driverSummaryPanel/driverSummaryPanel.component";
import { VehicleButtonFilterComponent } from "./vehicle-button-filter/vehicle-button-filter.component";
import { VehicleListComponent } from "./vehicle-list/vehicle-list.component";
import { VehicleStatusComponent } from "./vehicle-status/vehicle-status.component";
import { VehicleInfoCardComponent } from "./vehicleInfoCard/vehicleInfoCard.component";
import { VehiclePlotTimeComponent } from "./vehiclePlotTime/vehiclePlotTime.component";
import { VehicleRegComponent } from "./vehicleReg/vehicleReg.component";

const privateComponents = [];

const publicComponents = [
    VehicleInfoCardComponent,
    VehicleRegComponent,
    VehiclePlotTimeComponent,
    DriverSummaryPanelComponent,
    VehicleStatusComponent,
    VehicleButtonFilterComponent,
    VehicleListComponent
];

@NgModule({
    imports: [
        CommonModule,
        PipesModule,
        ScrollingModule,
        VeriDirectivesModule,
        MiscDirectivesModule,
        FormsDirectivesModule,
        MapDirectivesModule,
        ResourceFiltersDirectivesModule,
        CoreDirectivesModule
    ],
    declarations: [
        ...privateComponents,
        ...publicComponents,

    ],
    entryComponents: [
        ...privateComponents,
        ...publicComponents,
    ],
    exports: [
        ...publicComponents,
    ]
})
export class VehicleDirectivesModule {
    constructor() { }
}
